import { Injectable } from '@angular/core';
import { DataUtilService } from './data-util.service';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';


import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthHeader } from '../_models/headers';
import { ResultData } from '../_models/ResultData';
import { Syllabus } from '../_models/syllabus';
import { AuthService } from './auth.service';
import { HeaderService } from './header.service';


@Injectable({
  providedIn: 'root'
})



export class AdminService {

  aHeader = undefined
  headers = undefined
  options = undefined
  constructor(
    private headerService:HeaderService,
    private http: HttpClient,
    private dataUtilService:DataUtilService,
  private tss:AuthService) {

    this.headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.options = { headers: this.headers }
    this.aHeader= new AuthHeader(tss)
  }
    emitCode(){
      return this.http.get<any>(`${environment.apiUrl}/tool/emitcode`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let myData=[]
        if(this.dataUtilService.isGoodResponse(data)){
          myData= this.dataUtilService.myData(data)
        }
        return myData
      }))
    }
    testMailFunction(){
      return this.http.get<any>(`${environment.apiUrl}/tool/testmailfunction`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let myData=[]
        if(this.dataUtilService.isGoodResponse(data)){
          myData= this.dataUtilService.myData(data)
        }
        return myData
      }))
    }
    testFunction(){
      return this.http.get<any>(`${environment.apiUrl}/tool/testfunction`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let myData=[]
        if(this.dataUtilService.isGoodResponse(data)){
          myData= this.dataUtilService.myData(data)
        }
        return myData
      }))
    }
    getLevels() {
      return this.http.get<any>(`${environment.apiUrl}/level/index`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let myData=[]
        if(this.dataUtilService.isGoodResponse(data)){
          myData= this.dataUtilService.myData(data)
        }
        return myData
      }))
    }



    confirmAccountDelete(formData:any, id:number){
      let url=`${environment.apiUrl}/user/confirmAccountDelete/${id}`
      return this.http.post<any>(url, formData,this.aHeader.openFormHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }else{
            return {}
        }
      }))

    }
    requestAccountDelete(formData:string){
      let url=`${environment.apiUrl}/user/requestAccountDelete`
      return this.http.post<any>(url,formData,this.aHeader.openFormHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }else{
            return {}
        }
      }))

    }
    saveNewCountry(formData:FormData){
      let url=`${environment.apiUrl}/country/apisave`
      return this.http.post<any>(url, formData,this.aHeader.bearerFormMultipartHeaders).pipe(map(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }else{
            return {}
        }
      }))
    }
    getLevel(serverCountryId:number){
      return this.http.get<any>(`${environment.apiUrl}/level/getbyid?id=${serverCountryId}`,this.aHeader.bearerJsonHeaders).pipe(map(
        data=>{
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }
        }
      ))
    }
    getCountry(serverCountryId:number){
      return this.http.get<any>(`${environment.apiUrl}/country/getbyid?id=${serverCountryId}`,this.aHeader.bearerJsonHeaders).pipe(map(
        data=>{
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }
        }
      ))
    }
    renameAnswerTemplate(formData:string){
      return this.http.post(`${environment.apiUrl}/answerTemplate/rename`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    renameQuestionTemplate(formData:string):Observable<ResultData>{
      return this.http.post<ResultData>(`${environment.apiUrl}/taskTemplate/apirename`, formData, {headers:this.headerService.bearerFormHeaders()})
    }
    newSyllabus(syllabusItem: Syllabus) {
      return this.http.post(`${environment.apiUrl}/syllabus/apinew`, syllabusItem.formData(), this.aHeader.bearerFormHeaders)
        .pipe(map(sInfo => {
          if(this.dataUtilService.isGoodResponse(sInfo)){
           return this.dataUtilService.myData(sInfo)

          }
        }));
    }

    updateSyllabus(syllabusItem: Syllabus) {
      return this.http.post(`${environment.apiUrl}/syllabus/apiupdate/${syllabusItem.id}`, syllabusItem.formData(), this.aHeader.bearerFormHeaders)
        .pipe(map(sInfo => {
          if(this.dataUtilService.isGoodResponse(sInfo)){
           return this.dataUtilService.myData(sInfo)

          }
        }));
    }

    duplicateSyllabus(syllabusItem: Syllabus) {
      return this.http.post(`${environment.apiUrl}/syllabus/duplicate`, syllabusItem.formData(), this.aHeader.bearerFormHeaders)
        .pipe(map(sInfo => {
          if(this.dataUtilService.isGoodResponse(sInfo)){
           return this.dataUtilService.myData(sInfo)

          }
        }));
    }
    newExamSectionItem(formData:string){
      return this.http.post(`${environment.apiUrl}/examSection/save`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }

    updateExamSectionItem(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/examSection/updateMe/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    updateExamFormatItem(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/examStructure/updateMe/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    getExamSection(id:number){
      return this.http.get<any>(`${environment.apiUrl}/examSection/getExamSection/${id}`,this.aHeader.bearerJsonHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
    }
    getExamFormat(id:number){
      return this.http.get<any>(`${environment.apiUrl}/examStructure/getExamFormat/${id}`,this.aHeader.bearerJsonHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
    }
    addAbilityToTaskRequires(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/taskTemplate/addAbilityToTaskRequires/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    removeAbilityFromTaskRequires(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/taskTemplate/removeAbilityFromTaskRequires/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }

    addAbilityToTaskProvides(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/taskTemplate/addAbilityToTaskProvides/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    removeAbilityFromTaskProvides(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/taskTemplate/removeAbilityFromTaskProvides/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }

    addAbilityToAbility(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/ability/addAbilityToAbility/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }

    searchAbilityToAddToTaskTemplateProvides(formData:string, id:number){
      return this.http.post(`${environment.apiUrl}/ability/searchAbilityToAddToTaskTemplateProvides/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }

    searchAbilityToAddToTaskTemplateRequires(formData:string, id:number){
      return this.http.post(`${environment.apiUrl}/ability/searchAbilityToAddToTaskTemplateRequires/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    searchAbilityToAddToAbility(formData:string, id:number){
      return this.http.post(`${environment.apiUrl}/ability/searchAbilityToAddToAbility/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    removeAbilityFromAbility(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/ability/removeAbilityFromAbility/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    updateAbility(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/ability/updateMe/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    updateSubscriptionGrouping(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/learningGroup/updateMe/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    newSubscriptionGrouping(formData:string){
      return this.http.post(`${environment.apiUrl}/learningGroup/save`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }

    updateSubscriptionGroup(formData:string,id:number){
      return this.http.post(`${environment.apiUrl}/subscriptionGroup/updateMe/${id}`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    newSubscriptionGroup(formData:string){
      return this.http.post(`${environment.apiUrl}/subscriptionGroup/save`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    newAbility(formData:string){
      return this.http.post(`${environment.apiUrl}/ability/save`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    newExamFormatItem(formData:string){
      return this.http.post(`${environment.apiUrl}/examStructure/save`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }


    replaceQuestionTemplate(formData:string){
      return this.http.post(`${environment.apiUrl}/taskTemplate/replacetemplate`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    editLevel(formData:string){
      return this.http.post(`${environment.apiUrl}/level/editapi`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
    updatePermissions(formData:string){
      return this.http.post(`${environment.apiUrl}/user/updatePermissions`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));

    }

  getUserGroups() {
    return this.http.get<any>(`${environment.apiUrl}/user/permission/index`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getUsersByRole(id:number):Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/user/role/user/index/${id}`,{headers:this.headerService.bearerJsonHeaders()})
  }
  getUsers() {
    return this.http.get<any>(`${environment.apiUrl}/user/apiindex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  removeSection(server_exam_section_id:number){
    return this.http.get<any>(`${environment.apiUrl}/examStructure/removeSection/${server_exam_section_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getExamFormats() {
    return this.http.get<any>(`${environment.apiUrl}/examStructure/index`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getSubscriptionGroup(server_subscription_group_id:number) {
    return this.http.get<any>(`${environment.apiUrl}/subscriptionGroup/show/${server_subscription_group_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getSubscriptionGroups() {
    return this.http.get<any>(`${environment.apiUrl}/subscriptionGroup/list`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getSubscriptionGroupsByGuardian(server_user_id) {
    return this.http.get<any>(`${environment.apiUrl}/subscriptionGroup/byguardain/${server_user_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getSubscriptionGroupingStudentList(server_subscription_group_id:number) {
    return this.http.get<any>(`${environment.apiUrl}/learningGroup/studentList/${server_subscription_group_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getSubscriptionGroupings(server_guardian_id:number) {
    return this.http.get<any>(`${environment.apiUrl}/guardian/groupings_index/${server_guardian_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getSubscriptionGrouping(server_guardian_id:number) {
    return this.http.get<any>(`${environment.apiUrl}/learningGroup/show/${server_guardian_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getAbility(server_ability_id:number) {
    return this.http.get<any>(`${environment.apiUrl}/ability/show/${server_ability_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getFreeWorksheetRequests(){
    return this.http.get<any>(`${environment.apiUrl}/freeWorksheet/list`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  viewFreeWorksheet(uuid:string){
    return this.http.get<string>(`${environment.apiUrl}/quizEnvelop/publicWorksheetAdmin/${uuid}`,this.aHeader.openTextHeaders)

  }
  getAbilities() {
    return this.http.get<any>(`${environment.apiUrl}/ability/list`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }


  removeFactFromSubtopic(id:number,id2:number){
    return this.http.get<any>(`${environment.apiUrl}/fact/removeFactFromSubTopic/${id}?server_subtopic_id=${id2}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getFactsBySubtopic(subTopicId:number) {
    return this.http.get<any>(`${environment.apiUrl}/fact/indexBySubTopic/${subTopicId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myObjectData(data)
        }
      }
    ))
  }
  getRecomputeProgress() {
    return this.http.get<any>(`${environment.apiUrl}/analytic/recomputeprogress`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  testSend(mail:string){
    return this.http.get<any>(`${environment.apiUrl}/analytic/testSend?email=${mail}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getProgressEmailList() {
    return this.http.get<any>(`${environment.apiUrl}/analytic/getprogressemailist`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getProgressEmailByGuardianId(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/analytic/progressemail/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  upgradeEnrolment(id:number){
    return this.http.get<any>(`${environment.apiUrl}/admin/apiupgradeenrolment/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  extendEnrolment(data:string, id:number){
    return this.http.post(`${environment.apiUrl}/admin/apiextendenrolment/${id}`,data,this.aHeader.bearerFormHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))


  }

  updateEnrolmentVersion(id:number){
    return this.http.get<any>(`${environment.apiUrl}/admin/updateenrolmentversion/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }


  addRemoveQuizMode(questionTemplateId:number,quizModeId:number) {
    let body = new URLSearchParams();
    body.set('quizModeId', quizModeId.toString());

    const bb = body.toString()


    return this.http.post(`${environment.apiUrl}/taskTemplate/addremovequizmode/${questionTemplateId}`,bb,this.aHeader.bearerFormHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  saveAnswerTemplate(id:number,formData:FormData){
    let url=`${environment.apiUrl}/answerTemplate/save/${id}`
    return this.http.post<any>(url, formData, this.aHeader.bearerFormMultipartHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
         return this.dataUtilService.myData(x)
        }else{
          return {}
      }
    }))
  }
  saveQuestionTemplate(formData:FormData, server_task_template_id:number):Observable<ResultData>{

    let url=`${environment.apiUrl}/taskTemplate/apisave/${server_task_template_id}`
    return this.http.post<ResultData>(url, formData, {headers: this.headerService.bearerFormMultipartHeaders()})
  }
  getQuestionTemplateQuestionsById(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/taskTemplate/apishowquestions/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getAnswerTemplateById(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/answerTemplate/show/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getTaskTemplatesByFilter(filterText:string, syllabuscode:string) {
    return this.http.get<any>(`${environment.apiUrl}/taskTemplate/listByFilter/${filterText}/${syllabuscode}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getTaskTemplates() {
    return this.http.get<any>(`${environment.apiUrl}/taskTemplate/listAll`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getAgents() {
    return this.http.get<any>(`${environment.apiUrl}/agent/webIndex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getInvoices() {
    return this.http.get<any>(`${environment.apiUrl}/invoice/webIndex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getAccounts() {
    return this.http.get<any>(`${environment.apiUrl}/accountReceivable/webIndex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getDeviceSyncById(id:String) {
    return this.http.get<any>(`${environment.apiUrl}/admin/devicesyncbyid/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }



  getDeviceSync() {
    return this.http.get<any>(`${environment.apiUrl}/admin/devicesyncindex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getSubjects() {
    return this.http.get<any>(`${environment.apiUrl}/subject/index`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{

        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getBillingCharts() {
    return this.http.get<any>(`${environment.apiUrl}/billingChart/webIndex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getEnrollments():Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/student/enrolments`,{headers:this.headerService.bearerJsonHeaders()})
  }

  getAwards() {
    return this.http.get<any>(`${environment.apiUrl}/award/angularawardindex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getQuizEnvelops() {
    return this.http.get<any>(`${environment.apiUrl}/quizEnvelop/webIndex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{

        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getHistory() {
    return this.http.get<any>(`${environment.apiUrl}/history/webIndex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getAnswerTemplates() {
    return this.http.get<any>(`${environment.apiUrl}/answerTemplate/webIndex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  getBadges() {
    return this.http.get<any>(`${environment.apiUrl}/award/angularbadgeindex`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  searchTopics(val:string){
    return this.http.get<any>(`${environment.apiUrl}/topic/searchtopiclist?q=${val}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  searchQuestionTemplate(val:string,server_subtopic_id:number){
    return this.http.get<any>(`${environment.apiUrl}/taskTemplate/searchaddtemplatelist/${server_subtopic_id}?q=${val}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  searchTemplatesBySubTopics(val:string,server_subtopic_id:number):Observable<ResultData>{
    const h = this.headerService.bearerJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/searchTemplatesBySubTopics/${server_subtopic_id}/${val}`,{headers:h})

  }


  searchRoles(val:string,server_group_id:number){
    return this.http.get<any>(`${environment.apiUrl}/roleGroup/searchaddrolelist/${server_group_id}?q=${val}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  searchUsers(val:string,server_group_id:number){
    return this.http.get<any>(`${environment.apiUrl}/roleGroup/searchadduserlist/${server_group_id}?q=${val}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }

  searchAnswerTemplate(val:string,server_task_template_id:number){
    return this.http.get<any>(`${environment.apiUrl}/answerTemplate/searchaddtemplatelist/${server_task_template_id}?q=${val}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  searchStudent(val:string,server_guardian_id:number){
    return this.http.get<any>(`${environment.apiUrl}/profile/profilesearchlist/${server_guardian_id}?q=${val}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  addRoleGroupName(formData:string){
    return this.http.post(`${environment.apiUrl}/roleGroup/apiaddgroup`, formData, this.aHeader.bearerFormHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
  }

  addPermissionToGroup(server_role_id:number,server_group_id:number){
    return this.http.get<any>(`${environment.apiUrl}/roleGroup/apiaddrole/${server_group_id}?roleId=${server_role_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))

  }
  addUserToGroup(server_role_id:number,server_group_id:number){
    return this.http.get<any>(`${environment.apiUrl}/roleGroup/apiadduser/${server_group_id}?userId=${server_role_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))

  }
  addTemplateToSubTopic(server_template_id:number,server_subtopic_id:number):Observable<ResultData>{
    const h = this.headerService.bearerJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/addTemplate/${server_subtopic_id}/${server_template_id}`,{headers:h})
  }

  moveSubTopicToSubTopic(server_topic_id:number,server_subtopic_id:number){
    return this.http.get<any>(`${environment.apiUrl}/subTopic/apimove/${server_subtopic_id}?server_topic_id=${server_topic_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))

  }


  addTemplateToProficiency(server_template_id:number,server_proficiency_id:number){
    return this.http.get<any>(`${environment.apiUrl}/proficiency/addTemplate/${server_proficiency_id}?questionTemplateId=${server_template_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))

  }
  addAnswerTemplateToQuestionTemplate(server_answer_template_id:number,server_task_template_id:number):Observable<ResultData>{
    return this.http.get<ResultData>(`${environment.apiUrl}/taskTemplate/addSolution/${server_task_template_id}/${server_answer_template_id}`,{headers: this.headerService.bearerJsonHeaders()})


  }

  addStudentToGuardian(server_profile_id:number,server_guardian_id:number){
    return this.http.get<any>(`${environment.apiUrl}/guardian/apiaddstudent/${server_guardian_id}?profileId=${server_profile_id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))

  }

  deleteAnswerTemplateById(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/answerTemplate/apidelete/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  removeSolutionFromTaskTemplate(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/taskTemplate/removeSolution/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  deleteQuestionTemplateById(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/taskTemplate/apidelete/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  deleteStudentByUserId(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/student/apidelete/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  deleteGroupingByServerSubscriptionGroupingId(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/learningGroup/apidelete/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }



}

